import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../styling/shared/events.css';
import EventRow from './event-row.js';
import GraphQLConnector from './graphql-connector.js';

const propTypes = {
  // The text to be used on the search
  searchText: PropTypes.string,
};

class Events extends Component {

  renderResult(result) {
    const data = result.dataObj;
    if (data) {
      if (data.errors) {
        return (
          <div className="col text-center">
            <h3>Não foi possível buscar eventos no momento. Tente novamente
            mais tarde...</h3>
          </div>
        );
      } else {
        const results = data.events.nodes;
        if (results.length > 0) {
          return results.map((event) => {
            return (<EventRow event={event} key={event.id}/>);
          });
        }
      }
    }

    return (
      <div className="col text-center">
        <h3>Nenhum evento encontrado :(</h3>
      </div>
    );
  }

  render() {
    const {searchText} = this.props;

    return (
      <div className="container events" style={{backgroundColor: 'white'}}>
        <h3 class="pt-3 pb-3">
          Escolha uma data:
        </h3>
        <div className="row">
          <GraphQLConnector
          queryName="unfinishedEvents"
          variables={{"searchQuery": searchText}}
          render={(isLoading, result) => {
            if (isLoading) {
              return (
                <div className="col text-center">
                  <h3>Carregando eventos...</h3>
                </div>
              );
            } else {
              return this.renderResult(result);
            }
          }}/>
        </div>
      </div>
    );
  }
}

Events.propTypes = propTypes;

export default Events;



// WEBPACK FOOTER //
// ./src/component/shared/events.js